import { render } from "./instructionstable.vue?vue&type=template&id=17dccfe2&scoped=true"
import script from "./instructionstable.vue?vue&type=script&lang=js"
export * from "./instructionstable.vue?vue&type=script&lang=js"

import "./instructionstable.vue?vue&type=style&index=0&id=17dccfe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17dccfe2"]])

export default __exports__